import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization";

export function UpdateBtns({ reset }) {
  const dispatch = useDispatch();

  const filtersDirty = useSelector((state) => state.utilization.filtersDirty);
  const staffFiltersLoading = useSelector((state) => state.utilization.staffFiltersLoading);
  const classFiltersLoading = useSelector((state) => state.utilization.classFiltersLoading);

  const selectedClassFilters = useSelector((state) => state.utilization.selectedClassFilters);
  const selectedStaffFilters = useSelector((state) => state.utilization.selectedStaffFilters);
  const averageIsNotSelected = useSelector((state) => state.utilization.averageIsNotSelected);

  return filtersDirty && !classFiltersLoading && !staffFiltersLoading ? (
    <div className="action-buttons">
      <button
        className="submit"
        onClick={() => dispatch(actionCreators.updateData())}
        disabled={
          (!selectedClassFilters.length || !selectedStaffFilters.length) && averageIsNotSelected
        }
      >
        Update
      </button>
      <button className="submit reset" onClick={reset}>
        Reset
      </button>
    </div>
  ) : null;
}
